import { BASE_URL } from "../configs";
import { getAccessToken } from "../helpers/auth/token";
import { getQueryParamsString } from "../lib/utils";
import axiosInstance from "./axios"

export async function getWorklogs({ page, perPage, projectId, taskId, sortBy, sortType, startAt, endAt, users }) {
  let url = `${BASE_URL}/api/worklog?`;
  url += getQueryParamsString({ page, perPage, projectId, taskId, sortBy, sortType, startAt, endAt, users })

  const res = await axiosInstance.get(url)
  return res.data.Data;
}

export async function getWorklog(worklogId) {
  let url = `${BASE_URL}/api/worklog/${worklogId}`;

  const res = await axiosInstance.get(url)
  return res.data.Data;
}


export async function createWorklog(worklog) {
  let url = `${BASE_URL}/api/worklog?`;

  const res = await axiosInstance.post(url, worklog)
  return res.data.Data;
}

export async function updateWorklog(worklog) {
  let url = `${BASE_URL}/api/worklog/${worklog.id}`;

  const res = await axiosInstance.put(url, worklog)
  return res.data.Data;
}

export async function deleteWorklog(worklogId) {
  let url = `${BASE_URL}/api/worklog/${worklogId}`;

  const res = await axiosInstance.delete(url)
  return res.data.Data;
}

export async function sendSms(worklogId) {
  let url = `${BASE_URL}/api/worklog/send-sms/${worklogId}`;

  const res = await axiosInstance.post(url)
  return res.data.Data;
}

export async function printWorklog(worklogId) {
  const url = `${BASE_URL}/api/worklog/print/${worklogId}`;

  const res = await axiosInstance.get(url, {
    responseType: 'blob'
  })

  const fileName = `worklog-${worklogId}.pdf`
  const blobData = res.data

  const link = document.createElement("a")
  const objectUrl = window.URL.createObjectURL(blobData)
  link.href = objectUrl
  link.download = fileName
  link.click()
  link.remove()

  // Revoke the object URL to prevent memory leaks
  window.URL.revokeObjectURL(objectUrl)
}

export async function exportWorklogsToExcel({ projectId, taskId, sortBy, sortType, startAt, endAt, users }) {
  let url = `${BASE_URL}/api/worklog/export/excel?`;
  url += getQueryParamsString({ projectId, taskId, sortBy, sortType, startAt, endAt, users })

  const res = await axiosInstance.get(url, {
    responseType: 'blob'
  })

  const fileName = `worklogs.xlsx`
  const blobData = res.data

  const link = document.createElement("a")
  const objectUrl = window.URL.createObjectURL(blobData)
  link.href = objectUrl
  link.download = fileName
  link.click()
  link.remove()

  // Revoke the object URL to prevent memory leaks
  window.URL.revokeObjectURL(objectUrl)
}

export async function getWorklogActions({ page, perPage, worklogId, sortBy, sortType } = {}) {
  let url = `${BASE_URL}/api/worklog/actions?`;
  url += getQueryParamsString({ page, perPage, worklogId, sortBy, sortType })

  const res = await axiosInstance.get(url)
  return res.data.Data;
}
